export const appCs = {
  'Create human-reviewed comment drafts without automated LinkedIn access.': 'Vytv\u00e1\u0159ejte ru\u010dn\u011b kontrolovan\u00e9 n\u00e1vrhy koment\u00e1\u0159\u016f bez automatick\u00e9ho p\u0159\u00edstupu k LinkedInu.',
  'Manual safety mode': 'Bezpe\u010dn\u00fd ru\u010dn\u00ed re\u017eim',
  'Linirio does not scan profiles, fetch posts, read comments, or publish Engagement comments. Paste the post here, review the AI draft, and publish it yourself on LinkedIn.': 'Linirio neproch\u00e1z\u00ed profily, nestahuje p\u0159\u00edsp\u011bvky, ne\u010dte koment\u00e1\u0159e ani je nepublikuje. Vlo\u017ete sem p\u0159\u00edsp\u011bvek, zkontrolujte AI n\u00e1vrh a publikujte jej sami na LinkedInu.',
  'Add a post manually': 'P\u0159idat p\u0159\u00edsp\u011bvek ru\u010dn\u011b',
  'Author name': 'Jm\u00e9no autora',
  'Optional': 'Voliteln\u00e9',
  'LinkedIn post URL': 'URL p\u0159\u00edsp\u011bvku na LinkedInu',
  'Post text': 'Text p\u0159\u00edsp\u011bvku',
  'Paste the complete post text here.': 'Sem vlo\u017ete cel\u00fd text p\u0159\u00edsp\u011bvku.',
  'The URL is stored only. Linirio never opens or downloads it.': 'URL se pouze ulo\u017e\u00ed. Linirio ji nikdy neotev\u00edr\u00e1 ani nestahuje.',
  'Add post': 'P\u0159idat p\u0159\u00edsp\u011bvek',
  'Manual posts': 'Ru\u010dn\u011b vlo\u017een\u00e9 p\u0159\u00edsp\u011bvky',
  'No manual posts yet': 'Zat\u00edm zde nejsou ru\u010dn\u011b vlo\u017een\u00e9 p\u0159\u00edsp\u011bvky',
  'Paste a LinkedIn post above to create a reviewed comment draft.': 'Vlo\u017ete v\u00fd\u0161e LinkedIn p\u0159\u00edsp\u011bvek a vytvo\u0159te kontrolovan\u00fd n\u00e1vrh koment\u00e1\u0159e.',
  'Unknown author': 'Nezn\u00e1m\u00fd autor',
  'No draft yet': 'Zat\u00edm bez konceptu',
  'Delete manual post': 'Odstranit ru\u010dn\u00ed p\u0159\u00edsp\u011bvek',
  'Could not add the post.': 'P\u0159\u00edsp\u011bvek se nepoda\u0159ilo p\u0159idat.',
  'Could not delete the post.': 'P\u0159\u00edsp\u011bvek se nepoda\u0159ilo odstranit.',
  'Approve for manual posting': 'Schv\u00e1lit k ru\u010dn\u00edmu publikov\u00e1n\u00ed',
  'Comment ready to copy': 'Koment\u00e1\u0159 je p\u0159ipraven ke zkop\u00edrov\u00e1n\u00ed',
  'Copy comment': 'Kop\u00edrovat koment\u00e1\u0159',
  'Copied': 'Zkop\u00edrov\u00e1no',
  'Open LinkedIn': 'Otev\u0159\u00edt LinkedIn',
  'Mark as posted': 'Ozna\u010dit jako publikovan\u00e9',
  'Marked as manually posted': 'Ozna\u010deno jako ru\u010dn\u011b publikovan\u00e9',
  'Comment marked as posted': 'Koment\u00e1\u0159 byl ozna\u010den jako publikovan\u00fd',
  'ready_to_copy': 'P\u0159ipraveno ke kop\u00edrov\u00e1n\u00ed',
  'posted': 'Publikov\u00e1no ru\u010dn\u011b',
  'relations': 'Načítání kontaktů',
  'profiles': 'Kontrola příspěvků profilů',
  'enrichment': 'Doplňování detailů a komentářů',
  'Engagement': 'Zapojení',
  'All': 'Vše',
  'Unread': 'Nepřečtené',
  'Needs reply': 'Vyžaduje odpověď',
  'Search conversations...': 'Hledat v konverzacích...',
  'No conversations': 'Žádné konverzace',
  'Select a conversation': 'Vyberte konverzaci',
  'Type a message...': 'Napište zprávu...',
  'Add attachment': 'Přidat přílohu',
  'Sync inbox': 'Synchronizovat schránku',
  'Syncing...': 'Synchronizace...',
  'Generate AI reply': 'Vygenerovat odpověď AI',
  'AI Auto-Reply': 'Automatické odpovědi AI',
  'AI reply': 'Odpověď AI',
  'Mark as read': 'Označit jako přečtené',
  'Mark as unread': 'Označit jako nepřečtené',
  'Convert to lead': 'Převést na lead',
  'Delete conversation': 'Smazat konverzaci',
  'Lead details': 'Detail leadu',
  'Add lead': 'Přidat lead',
  'Import leads': 'Importovat leady',
  'Import CSV': 'Importovat CSV',
  'Import LinkedIn URLs': 'Importovat LinkedIn URL',
  'Search leads...': 'Hledat leady...',
  'No leads yet': 'Zatím žádné leady',
  'New task': 'Nový úkol',
  'Open tasks': 'Otevřené úkoly',
  'No tasks yet': 'Zatím žádné úkoly',
  'Task details': 'Detail úkolu',
  'Due date': 'Termín',
  'Priority': 'Priorita',
  'Low': 'Nízká',
  'Medium': 'Střední',
  'High': 'Vysoká',
  'Approval queue': 'Fronta schvalování',
  'No approvals yet': 'Zatím nic ke schválení',
  'Approve': 'Schválit',
  'Reject': 'Zamítnout',
  'Send approved reply': 'Odeslat schválenou odpověď',
  'Edit draft': 'Upravit návrh',
  'Draft': 'Návrh',
  'Create post': 'Vytvořit příspěvek',
  'New post': 'Nový příspěvek',
  'Publish': 'Publikovat',
  'Schedule': 'Naplánovat',
  'Scheduled': 'Naplánováno',
  'Published': 'Publikováno',
  'No posts yet': 'Zatím žádné příspěvky',
  'Overview': 'Přehled',
  'Activity': 'Aktivita',
  'Performance': 'Výkon',
  'Total conversations': 'Celkem konverzací',
  'Messages sent': 'Odeslané zprávy',
  'Replies received': 'Přijaté odpovědi',
  'Response rate': 'Míra odpovědí',
  'Google Calendar': 'Google Kalendář',
  'Connect Google': 'Připojit Google',
  'Reconnect Google': 'Znovu připojit Google',
  'Create booking': 'Vytvořit rezervaci',
  'Create booking first': 'Nejprve vytvořte rezervaci',
  'Connect Google to create booking': 'Připojte Google a vytvořte rezervaci',
  'Each client needs to connect their own Google Calendar before bookings can be created.': 'Každý klient musí před vytvářením rezervací připojit svůj vlastní Google Kalendář.',
  'Booking calendar': 'Kalendář rezervací',
  'Upcoming bookings': 'Nadcházející rezervace',
  'Past bookings': 'Minulé rezervace',
  'Cancelled bookings': 'Zrušené rezervace',
  'No bookings yet': 'Zatím žádné rezervace',
  'No start time': 'Bez času začátku',
  'Attendees, comma separated': 'Účastníci oddělení čárkou',
  'Linirio meeting': 'Schůzka Linirio',
  'Edit booking': 'Upravit rezervaci',
  'Cancel booking': 'Zrušit rezervaci',
  'Audit log': 'Auditní záznam',
  'No audit events yet': 'Zatím žádné auditní události',
  'Actor': 'Uživatel',
  'Action': 'Akce',
  'Time': 'Čas',
  'User management': 'Správa uživatelů',
  'Users': 'Uživatelé',
  'Client': 'Klient',
  'Role': 'Role',
  'Enter as user': 'Vstoupit jako uživatel',
  'Create post for client': 'Vytvořit příspěvek pro klienta',
  'No users found': 'Nebyli nalezeni žádní uživatelé',
  'Connect your LinkedIn': 'Připojte svůj LinkedIn',
  'Search conversations…': 'Hledat v konverzacích…',
  'Search...': 'Hledat...',
  'Add a message (optional)…': 'Přidat zprávu (volitelné)…',
  'Tags': 'Štítky',
  'Add a tag and press Enter': 'Přidejte štítek a stiskněte Enter',
  'Remove this conversation from your inbox? The LinkedIn thread is untouched.': 'Odebrat tuto konverzaci ze schránky? Vlákno na LinkedIn zůstane beze změny.',
  'Import Leads': 'Importovat leady',
  'Delete this lead?': 'Smazat tento lead?',
  'Nothing here yet': 'Zatím zde nic není',
  'No tasks in this view': 'V tomto zobrazení nejsou žádné úkoly',
  'Could not load tasks.': 'Úkoly se nepodařilo načíst.',
  'Could not load reports.': 'Reporty se nepodařilo načíst.',
  'No operational activity yet': 'Zatím žádná provozní aktivita',
  'Leads added per day': 'Leady přidané za den',
  'Could not load audit events.': 'Auditní události se nepodařilo načíst.',
  'Loading bookings': 'Načítání rezervací',
  'Checking local bookings and Google Calendar events.': 'Kontrolují se místní rezervace a události Google Kalendáře.',
  'Google events': 'Události Google',
  'Cancel this booking and remove the Google Calendar event?': 'Zrušit tuto rezervaci a odstranit událost z Google Kalendáře?',
  'Could not load Google calendars.': 'Google kalendáře se nepodařilo načíst.',
  'Could not load Google Calendar events.': 'Události Google Kalendáře se nepodařilo načíst.',
  'Could not load calendar bookings.': 'Rezervace se nepodařilo načíst.',
  'Could not create booking.': 'Rezervaci se nepodařilo vytvořit.',
  'Could not reschedule booking.': 'Rezervaci se nepodařilo přeplánovat.',
  'Could not cancel booking.': 'Rezervaci se nepodařilo zrušit.',
  'Admin Dashboard': 'Administrace',
  'Search users...': 'Hledat uživatele...',
  'Unsupported image': 'Nepodporovaný obrázek',
  'Image too large': 'Obrázek je příliš velký',
  'Unsupported video': 'Nepodporované video',
  'Video too large': 'Video je příliš velké',
  'Unsupported document': 'Nepodporovaný dokument',
  'Document too large': 'Dokument je příliš velký',
  'Rewrite failed': 'Přepsání se nezdařilo',
  'Invalid link': 'Neplatný odkaz',
  'Invalid schedule': 'Neplatný termín',
  'Schedule in the past': 'Termín je v minulosti',
  'Article title': 'Název článku',
  'Ask a question…': 'Položte otázku…',
  'Write your article…': 'Napište článek…',
  'Share your thoughts…': 'Sdílejte své myšlenky…',
  'Pick a valid date and time.': 'Vyberte platné datum a čas.',
  'Pick a time in the future.': 'Vyberte čas v budoucnosti.',
  'AI-created operational work will appear here when a conversation needs a quote, meeting, missing information, or a manual follow-up.': 'Operativní úkoly vytvořené AI se zde objeví, když konverzace vyžaduje nabídku, schůzku, doplnění informací nebo ruční navázání.',
  'AI reason:': 'Důvod AI:',
  'Next step:': 'Další krok:',
  'Suggested reply': 'Navržená odpověď',
  'No users': 'Žádní uživatelé',
  'Pick a user on the left to view their posts.': 'Vyberte uživatele vlevo a zobrazte jeho příspěvky.',
  'This user has not connected a LinkedIn account yet, so no live posts can be loaded and posting on their behalf is disabled.': 'Tento uživatel zatím nepřipojil LinkedIn účet, proto nelze načíst živé příspěvky ani publikovat jeho jménem.',
  'No posts yet.': 'Zatím žádné příspěvky.',
  'Client requested changes': 'Klient požádal o změny',
  'Publishing error': 'Chyba publikování',
  'User': 'Uživatel',
  'Joined': 'Registrace',
  'LinkedIn': 'LinkedIn',
  'OpenAI key': 'Klíč OpenAI',
  'Connect your LinkedIn account to start syncing messages.': 'Připojte svůj LinkedIn účet a začněte synchronizovat zprávy.',
  'No conversations yet': 'Zatím žádné konverzace',
  'All conversations loaded': 'Všechny konverzace jsou načteny',
  'No messages yet': 'Zatím žádné zprávy',
  'Select a conversation to start': 'Začněte výběrem konverzace',
  'No tags yet.': 'Zatím žádné štítky.',
  'Preview not available': 'Náhled není dostupný',
  'No inline preview for this file type': 'Pro tento typ souboru není dostupný náhled',
  'Use the Download button above to save it locally.': 'Pro místní uložení použijte tlačítko Stáhnout výše.',
  'When': 'Kdy',
  'Entity': 'Objekt',
  'Target': 'Cíl',
  'No body text': 'Bez textu',
  'Open document': 'Otevřít dokument',
  'Publishing failed': 'Publikování se nezdařilo',
  'Your change request': 'Váš požadavek na změnu',
  'No leads added in this period.': 'V tomto období nebyly přidány žádné leady.',
  'Import leads from URLs, CSV, or from the Inbox.': 'Importujte leady z URL, CSV nebo ze schránky.',
  'Click to upload CSV': 'Klikněte pro nahrání CSV',
  'Auto-outreach': 'Automatický outreach',
  'Queue these leads for automated outreach.': 'Zařadit tyto leady do automatizovaného outreach.',
  'Lead': 'Lead',
  'Last contact': 'Poslední kontakt',
  'Location': 'Lokalita',
  'Drop leads here': 'Přesuňte leady sem',
  'Existing approval media will be kept.': 'Stávající média schválení zůstanou zachována.',
  'Duration:': 'Délka:',
  'Previous': 'Předchozí',
  'More pages': 'Další stránky',
  'Previous slide': 'Předchozí snímek',
  'Next slide': 'Další snímek',
  'LinkedIn posts, comments, and editable engagement concepts.': 'LinkedIn příspěvky, komentáře a upravitelné koncepty zapojení.',
  'Sync posts': 'Synchronizovat příspěvky',
  'Syncing posts...': 'Synchronizace příspěvků...',
  'Generate drafts': 'Generovat koncepty',
  'Generating drafts...': 'Generování konceptů...',
  'Starting synchronization': 'Spouštění synchronizace',
  'Starting concept generation': 'Spouštění generování konceptů',
  'Build Concept': 'Vytvořit koncept',
  'Could not load Engagement data.': 'Data Engagementu se nepodařilo načíst.',
  'Sync failed. Try again later.': 'Synchronizace se nezdařila. Zkuste to později.',
  'Could not build the concept. Try again later.': 'Koncept se nepodařilo vytvořit. Zkuste to později.',
  'Connect LinkedIn first': 'Nejprve připojte LinkedIn',
  'Connect your LinkedIn account before syncing posts.': 'Před synchronizací příspěvků připojte svůj LinkedIn účet.',
  'Open LinkedIn settings': 'Otevřít nastavení LinkedIn',
  'Reconnect LinkedIn': 'Znovu připojit LinkedIn',
  'Posts': 'Příspěvky',
  'Syncs': 'Synchronizace',
  'No posts synced yet': 'Zatím nejsou synchronizovány žádné příspěvky',
  'Sync posts to discover recent LinkedIn content and comments.': 'Synchronizujte příspěvky a načtěte aktuální obsah a komentáře z LinkedInu.',
  'Selected': 'Vybráno',
  'Select': 'Vybrat',
  'No post text available.': 'Text příspěvku není dostupný.',
  'reactions': 'reakcí',
  'comments': 'komentářů',
  'Synced': 'Synchronizováno',
  'Open post': 'Otevřít příspěvek',
  'Comments': 'Komentáře',
  'No comments available.': 'Nejsou dostupné žádné komentáře.',
  'Concept ready': 'Koncept je připraven',
  'Engagement concept': 'Koncept zapojení',
  'Post preview': 'Náhled příspěvku',
  'Your editable concept': 'Váš upravitelný koncept',
  'Saving keeps this as a draft. Nothing is published to LinkedIn.': 'Uložením zůstane koncept jako návrh. Na LinkedIn se nic nepublikuje.',
  'Save concept': 'Uložit koncept',
  'Could not save the concept.': 'Koncept se nepodařilo uložit.',
  'Concept saved. Nothing was published to LinkedIn.': 'Koncept byl uložen. Na LinkedIn se nic nepublikovalo.',
  'Synchronization status': 'Stav synchronizace',
  'LinkedIn connection': 'Připojení LinkedIn',
  'Connected': 'Připojeno',
  'Not connected': 'Nepřipojeno',
  'Posts stored': 'Uložené příspěvky',
  'Posts sync': 'Synchronizace příspěvků',
  'Last error': 'Poslední chyba',
  'None': 'Žádná',
  'Create Concepts': 'Vytvořit koncepty',
  'Creating concepts': 'Vytváření konceptů',
  'All loaded posts already have a concept.': 'Všechny načtené příspěvky už mají koncept.',
  'Could not build the concepts. Try again later.': 'Koncepty se nepodařilo vytvořit. Zkuste to později.',
  'Comment concept': 'Návrh komentáře',
  'Review or edit concept': 'Zkontrolovat nebo upravit koncept',
  'Approved': 'Schváleno',
  'Rejected': 'Zamítnuto',
  'Concept saved as a draft. Nothing was published to LinkedIn.': 'Koncept byl uložen jako návrh. Na LinkedIn se nic nepublikovalo.',
  'Approved internally. Nothing was published to LinkedIn.': 'Interně schváleno. Na LinkedIn se nic nepublikovalo.',
  'Concept rejected. Nothing was published to LinkedIn.': 'Koncept byl zamítnut. Na LinkedIn se nic nepublikovalo.',
  'Manual approval only changes the internal status. Nothing is published to LinkedIn.': 'Ruční schválení mění pouze interní stav. Na LinkedIn se nic nepublikuje.',
  'Reject concept': 'Zamítnout koncept',
  'Save draft': 'Uložit návrh',
  'Approve concept': 'Schválit koncept',
  'To-do': 'K vyřízení',
  'Follow-up': 'Následné reakce',
  'Sync': 'Synchronizace',
  'Discover, review, and follow up on LinkedIn conversations.': 'Objevujte, kontrolujte a sledujte LinkedIn konverzace.',
  'LinkedIn synchronization': 'Synchronizace LinkedInu',
  'Concept generation': 'Vytváření konceptů',
  'queued': 'Ve frontě',
  'processing': 'Probíhá',
  'completed': 'Dokončeno',
  'failed': 'Selhalo',
  'posts selected': 'vybraných příspěvků',
  'approvals created': 'vytvořených schválení',
  'No synchronization jobs yet': 'Zatím neproběhla žádná synchronizace',
  'Start Sync to discover recent LinkedIn posts.': 'Spusťte synchronizaci a načtěte aktuální příspěvky z LinkedInu.',
  'No follow-ups yet': 'Zatím nejsou žádné následné reakce',
  'Posts move here after your approved comment is sent.': 'Příspěvky se sem přesunou po odeslání schváleného komentáře.',
  'No posts to review': 'Žádné příspěvky ke kontrole',
  'Run Sync to build a fresh 12-hour feed.': 'Spusťte synchronizaci a vytvořte aktuální feed za posledních 12 hodin.',
  'LinkedIn member': 'Člen LinkedInu',
  'need a reply': 'vyžaduje odpověď',
  'Pending approval': 'Čeká na schválení',
  'Date unavailable': 'Datum není dostupné',
  'Your sent comment': 'Váš odeslaný komentář',
  'Post comments': 'Komentáře',
  'Reply to a post comment': 'Odpověď na komentář u příspěvku',
  'Comment on a post': 'Komentář k příspěvku',
  'RAG draft': 'RAG návrh',
  'Draft variants': 'Varianty n\u00e1vrhu',
  'Playful': 'Hrav\u00e1',
  'Curious': 'Zv\u011bdav\u00e1',
  'Bold perspective': 'Odv\u00e1\u017en\u00fd pohled',
  'Recommended': 'Doporu\u010deno',
  'Could not save the draft.': 'N\u00e1vrh se nepoda\u0159ilo ulo\u017eit.',
  'Comment sent': 'Komentář byl odeslán',
  'Comment rejected': 'Komentář byl zamítnut',
  'Comment scheduled': 'Koment\u00e1\u0159 byl napl\u00e1nov\u00e1n',
  'Comments scheduled': 'Koment\u00e1\u0159e byly napl\u00e1nov\u00e1ny',
  'Approve & schedule': 'Schv\u00e1lit a napl\u00e1novat',
  'Approve selected & schedule': 'Schv\u00e1lit vybran\u00e9 a napl\u00e1novat',
  'Approve and schedule comments': 'Schv\u00e1lit a napl\u00e1novat koment\u00e1\u0159e',
  'Select all': 'Vybrat v\u0161e',
  'Select comment': 'Vybrat koment\u00e1\u0159',
  'Selected': 'Vybr\u00e1no',
  'Active hours': 'Aktivn\u00ed hodiny',
  'Timezone': '\u010casov\u00e9 p\u00e1smo',
  'Confirm schedule': 'Potvrdit pl\u00e1n',
  'Scheduling...': 'Pl\u00e1nov\u00e1n\u00ed...',
  'Scheduling failed': 'Pl\u00e1nov\u00e1n\u00ed selhalo',
  'Scheduled for': 'Napl\u00e1nov\u00e1no na',
  'the next active window': 'nejbli\u017e\u0161\u00ed aktivn\u00ed okno',
  'Estimated completion': 'P\u0159edpokl\u00e1dan\u00e9 dokon\u010den\u00ed',
  'Only approved comments will be sent. Follow-ups have priority and the rolling limit is 30 comments per 24 hours.': 'Ode\u0161lou se pouze schv\u00e1len\u00e9 koment\u00e1\u0159e. N\u00e1sledn\u00e9 reakce maj\u00ed prioritu a pr\u016fb\u011b\u017en\u00fd limit je 30 koment\u00e1\u0159\u016f za 24 hodin.',
  'Media preview is unavailable or has expired.': 'N\u00e1hled m\u00e9dia nen\u00ed dostupn\u00fd nebo vypr\u0161ela jeho platnost.',
  'Open on LinkedIn': 'Otev\u0159\u00edt na LinkedInu',
  'LinkedIn document': 'Dokument LinkedIn',
  'Open document': 'Otev\u0159\u00edt dokument',
  'media items': 'm\u00e9di\u00ed',
  'LinkedIn poll': 'Anketa LinkedIn',
  'Read-only poll': 'Anketa je pouze pro \u010dten\u00ed',
  'Article': '\u010cl\u00e1nek',
  'Reposted from': 'P\u0159esd\u00edleno od',
  'Engagement scheduling': 'Pl\u00e1nov\u00e1n\u00ed zapojen\u00ed',
  'Approved comments are sent irregularly inside active hours. Full autopilot is disabled.': 'Schv\u00e1len\u00e9 koment\u00e1\u0159e se odes\u00edlaj\u00ed nepravideln\u011b v aktivn\u00edch hodin\u00e1ch. Pln\u00fd autopilot je vypnut\u00fd.',
  'Active from': 'Aktivn\u00ed od',
  'Active until': 'Aktivn\u00ed do',
  'Manual approval only': 'Pouze ru\u010dn\u00ed schv\u00e1len\u00ed',
  'comments per rolling 24 hours': 'koment\u00e1\u0159\u016f za pr\u016fb\u011b\u017en\u00fdch 24 hodin',
  'Follow-ups are sent first': 'N\u00e1sledn\u00e9 reakce se odes\u00edlaj\u00ed p\u0159ednostn\u011b',
  'Save schedule': 'Ulo\u017eit pl\u00e1n',
  'Engagement schedule saved.': 'Pl\u00e1n zapojen\u00ed byl ulo\u017een.',
  'Preparing...': 'P\u0159ipravuji...',
  'Could not prepare schedule': 'Pl\u00e1n se nepoda\u0159ilo p\u0159ipravit',
  'LinkedIn comment': 'Koment\u00e1\u0159 na LinkedInu',
  'Exact times are reserved for 10 minutes.': 'P\u0159esn\u00e9 \u010dasy jsou rezervov\u00e1ny 10 minut.',
  'Regenerate all': 'P\u0159egenerovat v\u0161e',
  'Regenerate again': 'P\u0159egenerovat znovu',
  'Regenerate concepts': 'P\u0159egenerovat koncepty',
  'Regenerate': 'P\u0159egenerovat',
  'Regenerating...': 'P\u0159egenerov\u00e1v\u00e1n\u00ed...',
  'Could not prepare regeneration.': 'P\u0159egenerov\u00e1n\u00ed se nepoda\u0159ilo p\u0159ipravit.',
  'Could not regenerate the concepts.': 'Koncepty se nepoda\u0159ilo p\u0159egenerovat.',
  'All unsent concepts will be removed and rebuilt with your current Engagement Voice and Knowledge Base. Sent comments remain unchanged.': 'V\u0161echny neodeslan\u00e9 koncepty budou odstran\u011bny a znovu vytvo\u0159eny podle aktu\u00e1ln\u00edho Engagement Voice a Knowledge Base. Odeslan\u00e9 koment\u00e1\u0159e z\u016fstanou beze zm\u011bny.',
  'Concepts to replace': 'Koncepty k nahrazen\u00ed',
  'Scheduled to cancel': 'Pl\u00e1novan\u00e9 ke zru\u0161en\u00ed',
  'comments are currently sending and will not be changed.': 'koment\u00e1\u0159\u016f se pr\u00e1v\u011b odes\u00edl\u00e1 a nebudou zm\u011bn\u011bny.',
  'Synchronization and generation': 'Synchronizace a generov\u00e1n\u00ed',
  'Scheduled comments': 'Napl\u00e1novan\u00e9 koment\u00e1\u0159e',
  'Comment schedule': 'Harmonogram koment\u00e1\u0159\u016f',
  'Pause': 'Pozastavit',
  'Resume': 'Pokra\u010dovat',
  'Cancel batch': 'Zru\u0161it d\u00e1vku',
  'Could not update the schedule.': 'Harmonogram se nepoda\u0159ilo aktualizovat.',
  'active': 'Aktivn\u00ed',
  'paused': 'Pozastaveno',
  'cancelled': 'Zru\u0161eno',
  'scheduled': 'Napl\u00e1nov\u00e1no',
  'sending': 'Odes\u00edl\u00e1 se',
  'sent': 'Odesl\u00e1no',
};
